 
import React, { useEffect, useState } from 'react';

import { Row, Col } from 'react-bootstrap';

import Text from 'v3/components/Text';
import Button from 'v3/components/Button';
import { useSnackbar } from 'v3/components/Snackbar';

import * as Controller from './controller';

export default function Cargon({ load, loadId, onGoingTravelStatusId }) {
  const snackbar = useSnackbar();

  const [isForwarded, setForwarded] = useState(false);
  const [isAvailable, setAvailable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [optionsOpened, setOptionsOpened] = useState(false);

  useEffect(() => {
    async function fetchIsAvailable() {
      setAvailable(true);
    }

    fetchIsAvailable();
  }, []);

  useEffect(() => {
    async function checkForwarded() {
      try {
        if (load.data?.automationLog.find((automation) => automation.name === 'Cargon')) {
          setForwarded(true);
        }
      } catch (error) {
        // catch
      }
    }

    if (optionsOpened) checkForwarded();
  }, [optionsOpened]);

  async function send() {
    setLoading(true);
    const resp = await Controller.send(loadId);
    snackbar.show(<Text>{resp.message}</Text>, {
      type: resp.error ? 'error' : 'success',
    });
    setLoading(false);
    if (resp.error) setForwarded(false);
    else setForwarded(true);
  }

  async function cancel() {
    setLoading(true);
    const resp = await Controller.cancel(loadId);

    snackbar.show(<Text>{resp.message}</Text>, {
      type: resp.error ? 'error' : 'success',
    });
    setLoading(false);
    if (resp.error) setForwarded(true);
    else setForwarded(false);
  }

  if (isAvailable) {
    return (
      <Row md={12}>
        <Col md={6} className="d-flex flex-column">
          <Text type="header" color="dark" weight="600">
            Cargon
          </Text>
          {!optionsOpened && (
            <Button
              className="mt-2"
              disabled={onGoingTravelStatusId(load?.travel?.statusId)}
              variant="secondary"
              size="sm"
              loading={loading}
              onClick={() => {
                setOptionsOpened(true);
              }}
            >
              <Text weight={500} type="regular">
                Abrir opções
              </Text>
            </Button>
          )}
        </Col>
        {optionsOpened && (
          <>
            <Col md={12}>
              <Button
                className="mt-2"
                variant="success"
                loading={loading}
                onClick={() => send(loadId)}
              >
                <Text weight={500} type="regular">
                  Enviar
                </Text>
              </Button>
              <Button
                className="ml-2 mt-2"
                variant="error"
                loading={loading}
                onClick={() => cancel(loadId)}
              >
                <Text weight={500} type="regular">
                  Cancelar
                </Text>
              </Button>
            </Col>
          </>
        )}
      </Row>
    );
  }

  return null;
}
